import React from 'react';
import { cn } from '@/lib/utils';
interface Tab {
  label: string;
  value: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onUpdateActiveTab: (value: string) => void;
  clsWrapper?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onUpdateActiveTab,
  clsWrapper
}) => {
  return (
    <div className={cn('mb-3 px-4', clsWrapper)}>
      <div className="flex gap-4">
        {tabs.map(tab => (
          <div
            key={tab.value}
            className="flex cursor-pointer flex-col items-center gap-1"
            onClick={() => onUpdateActiveTab(tab.value)}
          >
            <span
              className={`text-sm font-medium transition-colors ${
                activeTab === tab.value ? 'text-[#5959EB]' : 'text-[#1F1F1F]'
              }`}
            >
              {tab.label}
            </span>
            {activeTab === tab.value && <div className="h-1 w-[18px] rounded-full bg-[#5959EB]" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
